import { render, staticRenderFns } from "./judge-registration-pdf.vue?vue&type=template&id=054f5132&scoped=true&"
import script from "./judge-registration-pdf.vue?vue&type=script&lang=js&"
export * from "./judge-registration-pdf.vue?vue&type=script&lang=js&"
import style0 from "./judge-registration-pdf.vue?vue&type=style&index=0&id=054f5132&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "054f5132",
  null
  
)

export default component.exports